import CourtyardGateScene from './CourtyardGateScene';

export default function FantasyGateScene({ selected = false }) {
  return <CourtyardGateScene fantasy selected={selected} />;
}
